import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';

import { useProfileContext } from '@/contexts/profile';
import { EAdminRoutes } from '@/services/router/enums.ts';

export const useAuthRedirect = (): void => {
    const location = useLocation();
    const navigate = useNavigate();
    const { isAuthorized, loading } = useProfileContext();
    const isAuthRoute = location.pathname !== EAdminRoutes.Login;

    useEffect(() => {
        if (!loading) {
            if (isAuthRoute) {
                if (!isAuthorized) {
                    navigate(EAdminRoutes.Login);
                }
            } else {
                if (isAuthorized) {
                    navigate(EAdminRoutes.Dashboard);
                }
            }
        }
    }, [isAuthRoute, isAuthorized, loading, navigate]);
};
